module.exports = {
    "_id": "00aebfc6-7036-11ec-abf7-ddec11050504",
    "idPeriod": "",
    "prefData": {"includeOrResident": 1, "defaultMailingLists": []},
    "products": {
        "flyers": {
            "options": {"pdfDownload": 0, "defaultCoating": "", "defaultQuantity": 0, "defaultCoatingSide": 3},
            "templates": {"sold": "", "openHouse": "", "newListing": "", "priceChange": ""},
            "quantities": {"sold": 0, "openHouse": 0, "newListing": 0, "priceChange": 0}
        },
        "brochures": {
            "options": {
                "pdfDownload": 0,
                "defaultCoating": "",
                "defaultQuantity": 0,
                "defaultCoatingSide": 3
            },
            "templates": {"sold": "", "openHouse": "", "newListing": "", "priceChange": ""},
            "quantities": {"sold": 0, "openHouse": 0, "newListing": 0, "priceChange": 0}
        },
        "postcards": {
            "options": {
                "pdfDownload": 0,
                "defaultCoating": "",
                "defaultQuantity": 0,
                "mailClassDefault": "",
                "defaultCoatingSide": 1
            },
            "comments": {"sold": "", "openHouse": "", "newListing": "", "priceChange": ""},
            "templates": {"sold": "366160", "openHouse": "366160", "newListing": "366160", "priceChange": "366160"},
            "quantities": {"sold": 0, "openHouse": 0, "newListing": 0, "priceChange": 0}
        },
        "socialMedia": {
            "options": {"defaultUrl": ""},
            "templates": {"sold": "", "openHouse": "", "newListing": "", "priceChange": ""}
        },
        "imageDownload": {
            "options": {"defaultFileType": ""},
            "templates": {"sold": "", "openHouse": "", "newListing": "", "priceChange": ""}
        }
    },
    "createdAt": "2022-01-08 03:49:38 UTC",
    "idAccount": "378b485f08",
    "idPrimary": "4499020",
    "idProgram": "7b61c906",
    "updatedAt": "2022-06-01 21:02:52 UTC",
    "dateCreated": "2022-01-07 21:49:36",
    "dateModified": "2022-06-01 16:02:52",
    "complianceDetails": {"subscribe": 1}
};
